import { Box, styled } from '@mui/material';

import { NativeVaultColor } from '@/theme/colorSchemes';

export const resolveSnapshotBgColor = (
  backgroundColor: string | null,
  isNative?: boolean
): string | null => backgroundColor ?? (isNative ? NativeVaultColor : null);

export const SnapshotIndicator = (props: {
  backgroundColor: string | null;
  isPartial?: boolean;
  isNative?: boolean;
  sx?: object;
}) => {
  const bgColor = resolveSnapshotBgColor(props.backgroundColor, props.isNative);
  return props.isPartial ? (
    <PartialSnapshotIndicator backgroundColor={bgColor} sx={props.sx} />
  ) : (
    <FullSnapshotIndicator backgroundColor={bgColor} sx={props.sx} />
  );
};

const FullSnapshotIndicator = styled('div')(
  (props: { backgroundColor: string | null; sx?: object }) => ({
    height: '12px',
    width: '12px',
    borderRadius: '50%',
    display: 'inline-block',
    minWidth: '12px',
    minHeight: '12px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: props.backgroundColor || 'gray',
    backgroundColor: props.backgroundColor || 'transparent',
    ...props.sx,
  })
);

const PartialSnapshotIndicator = (props: {
  backgroundColor: string | null;
  sx?: object;
}) => {
  return (
    <Box
      sx={{
        height: '12px',
        width: '12px',
        borderRadius: '50%',
        display: 'inline-block',
        minWidth: '12px',
        minHeight: '12px',
        border: `2px solid ${props.backgroundColor}`,
        overflow: 'hidden',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          marginTop: '-1.5px',
          marginLeft: '-3px',
          height: '5px',
          width: '12px',
          transform: 'rotate(-45deg)',
          backgroundColor: props.backgroundColor,
        }}
      ></Box>
    </Box>
  );
};
